export const routeForDashboard = '/';
export const routeForSummary = '/summary';
export const routeForDevices = '/devices';
export const routeForDevice = '/devices/:id';

export type UserRouteParams = {
    id: string;
};

export const routeForNewDevice = '/devices/new';

export const getDeviceRoute = (deviceId: string) => {
    return `/devices/${deviceId}`;
};
